import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import { FaEnvelope, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import DefaultData from '../../CompanyData/DefaultData';

const EMAIL_CONTACTS = [
  { label: 'Booking Queries', email: 'ops@zotrai.com' },
  { label: 'Tech Issues', email: 'tech@zotrai.com' },
  { label: 'General Issues', email: 'support@zotrai.com' },
];

export default function HelpContactPanel({ show, onHide }) {
  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title style={{ color: DefaultData.THEMECOLOR2 }}>
          Get in Touch
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="d-flex flex-column gap-3">
          <a
            href="tel:+917842035522"
            className="d-flex align-items-center text-decoration-none p-3"
            style={{
              border: '1px solid #eee',
              borderRadius: '8px',
              color: DefaultData.THEMECOLOR2,
              gap: '12px',
            }}
          >
            <FaPhoneAlt style={{ color: DefaultData.THEMECOLOR1, fontSize: '16px' }} />
            <div>
              <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>Call Us</div>
              <div style={{ fontSize: '0.85rem', color: '#666' }}>+91 78420 35522</div>
            </div>
          </a>

          <a href="https://wa.me/917842035522?text=Hi%20ZOTRAI" target="_blank" rel="noopener noreferrer"
              className="d-flex align-items-center text-decoration-none p-3"
              style={{
                border: '1px solid #eee',
                borderRadius: '8px',
                color: DefaultData.THEMECOLOR2,
                gap: '12px',
              }}
            >

            <FaWhatsapp style={{ color: '#25D366', fontSize: '18px' }} />
            <div>
              <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>WhatsApp</div>
              <div style={{ fontSize: '0.85rem', color: '#666' }}>+91 78420 35522</div>
            </div>
          </a>

          {EMAIL_CONTACTS.map(({ label, email }) => (
            <a
              key={email}
              href={`mailto:${email}`}
              className="d-flex align-items-center text-decoration-none p-3"
              style={{
                border: '1px solid #eee',
                borderRadius: '8px',
                color: DefaultData.THEMECOLOR2,
                gap: '12px',
              }}
            >
              <FaEnvelope style={{ color: DefaultData.THEMECOLOR1, fontSize: '18px' }} />
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>{label}</div>
                <div style={{ fontSize: '0.85rem', color: '#666' }}>{email}</div>
              </div>
            </a>
          ))}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
